"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterSelector = void 0;
var _imageEditing = require("../utils/imageEditing");
var _jsxRuntime = require("react/jsx-runtime");
const FilterSelector = ({
  crop,
  image,
  selectedFilter,
  onSelect
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "control-group",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      children: "Filters"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "filter-grid",
      children: _imageEditing.basicFilters.map(filter => /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: selectedFilter === filter.id ? 'filter-preview-card active' : 'filter-preview-card',
        type: "button",
        onClick: () => onSelect(filter.id),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "filter-preview-image",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: image.previewUrl,
            alt: `${filter.label} preview`,
            style: {
              filter: filter.css,
              objectPosition: `${crop.x}% ${crop.y}%`
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "filter-preview-label",
          children: filter.label
        })]
      }, filter.id))
    })]
  });
};
exports.FilterSelector = FilterSelector;